import React from "react";

import { Paragraph, Small } from "@fronterahealth/frontera-ui-components";

interface GeneralInfoProps {
  clientName: string;
  dateOfBirth: string;
  gender: string;
  age: string;
  address: string;
  evaluationDate: string;
  examiner: string;
}

const GeneralInfoTable: React.FC<GeneralInfoProps> = ({
  clientName,
  dateOfBirth,
  gender,
  age,
  address,
  evaluationDate,
  examiner,
}) => {
  return (
    <div className="pt-6 w-full">
      <div className=" border-collapse border border-limestone-200 rounded-2xl">
        <table className="w-full" data-uniform-width="true">
          <colgroup>
            <col style={{ width: "25%" }} />
            <col style={{ width: "25%" }} />
            <col style={{ width: "25%" }} />
            <col style={{ width: "25%" }} />
          </colgroup>
          <thead className="sr-only">
            <tr>
              <th scope="col">Client&apos;s Name</th>
              <th scope="col">Date of Birth</th>
              <th scope="col">Address</th>
              <th scope="col">Date of Report / Examiner</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b  border-limestone-200 align-top">
              <td className="p-3 border-r  border-limestone-200 align-top">
                <Paragraph>Client’s name</Paragraph>
                <Small colorType="primary" className="ph-no-capture">
                  {clientName}
                </Small>
              </td>
              <td className="p-3 border-r  border-limestone-200 align-top">
                <Paragraph>Date of birth</Paragraph>
                <Small colorType="primary" className="ph-no-capture">
                  {dateOfBirth}
                </Small>
              </td>
              <td className="p-3 border-r  border-limestone-200 align-top" rowSpan={2}>
                <Paragraph>Address</Paragraph>
                <Small colorType="primary" className="ph-no-capture">
                  {address}
                </Small>
              </td>
              <td className="p-3 align-top">
                <Paragraph>Date of Report</Paragraph>
                <Small colorType="primary">{evaluationDate}</Small>
              </td>
            </tr>
            <tr className="align-top">
              <td className="p-3 border-r border-limestone-200 align-top">
                <Paragraph>Gender</Paragraph>
                <Small colorType="primary" className="ph-no-capture">
                  {gender}
                </Small>
              </td>
              <td className="p-3 border-r border-limestone-200 align-top">
                <Paragraph>Age</Paragraph>
                <Small colorType="primary" className="ph-no-capture">
                  {age}
                </Small>
              </td>
              <td className="p-3 align-top">
                <Paragraph>Examiner</Paragraph>
                <Small colorType="primary" className="ph-no-capture">
                  {examiner}
                </Small>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GeneralInfoTable;
